import { useGalleryUrl } from '~/app/features/Gallery/hooks/useGalleryUrl'
import { useSearchParams } from '~/app/features/Gallery/hooks/useSearchParams'

export const usePaginationLink = (page: number): string => {
  const searchParams = useSearchParams()

  const galleryUrl = useGalleryUrl()

  searchParams.forEach((value, key) => {
    galleryUrl.searchParams.set(key, value)
  })

  galleryUrl.searchParams.delete('page')
  galleryUrl.searchParams.delete('qv')

  if (page > 1) {
    galleryUrl.searchParams.set('page', page.toString())
  }

  return galleryUrl.toString()
}
